import { mapGetters } from 'vuex';
import Contract from '@/models/contract';
import marketContractInfoV2, { MARKET_CONTRACT_INFO_VALUES_LAYOUT } from '@/components/market/v2/market-contract-info-v2/market-contract-info-v2.vue';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';


export default {
  props: {
    openNewTab: {
      type: Boolean,
      default: false,
    },
    contracts: {
      type: Array,
      default: () => [],
    },
    trackingContext: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    marketChangePrice,
    marketContractInfoV2,
  },
  data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    items() {
      return this.contracts.map((i) => {
        const instance = new Contract(i);
        return {
          id: i.contractId,
          marketName: i.marketName,
          marketId: i.marketId,
          contractName: i.contractName,
          image: i.contractImageSmallUrl || i.contractImageUrl,
          price: instance.changePriceAsCents,
          priceAsCents: instance.lastTradePriceAsCents,
          hasLastTradePrice: instance.hasLastTradePrice,
          lastClosePrice: instance.lastClosePrice,
        };
      });
    },
  },
  methods: {
    itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id },
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/cms/market-contract-list-v2-embed-compact/market-contract-list-v2-embed-compact.js